import React, { useEffect, useState } from "react";
import brandLogoDark from "../utils/brandLogo";
import rsaController from "../utils/RSA-controller";
import { fetchAndStoreServerPublicKey } from "../utils/apiClient";

const SplashScreen = ({ onReady }) => {
  const [message, setMessage] = useState("");

  const MIN_DISPLAY_TIME_MS = 100; // 5 seconds

  useEffect(() => {
    let cancelled = false;
    const startTime = Date.now();

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const ensureMinDisplayTime = async () => {
      const elapsed = Date.now() - startTime;
      if (elapsed < MIN_DISPLAY_TIME_MS) {
        await delay(MIN_DISPLAY_TIME_MS - elapsed);
      }
    };

    const initialize = async () => {
      while (!cancelled) {
        if (typeof navigator !== "undefined" && !navigator.onLine) {
          setMessage("No internet connection. Waiting to reconnect...");
          await delay(3000);
          continue;
        }

        try {
          setMessage("");

          // Ensure local RSA keypair exists (required for encryption)
          await rsaController.getUserPublicKey();

          // Public key is required before login. Retry on splash instead of
          // letting the login page show a bootstrap error field.
          await fetchAndStoreServerPublicKey();

          await ensureMinDisplayTime();

          if (!cancelled && typeof onReady === "function") {
            onReady();
          }
          return;
        } catch (error) {
          // Keep user on splash and retry on real failures (e.g. crypto APIs)
          // but avoid tight loops.
          // eslint-disable-next-line no-console
          console.error("Error during splash initialization. Retrying...", error);
          setMessage("Connection problem. Retrying...");
          await delay(3000);
        }
      }
    };

    initialize();

    return () => {
      cancelled = true;
    };
  }, [onReady]);

  return (
    <div className="splash-screen">
      <div className="splash-content">
        <img src={brandLogoDark} alt="MFG Invest" className="splash-logo" />
        {message && (
          <p className="splash-message">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default SplashScreen;

